<script setup>
import { inject } from 'vue';
import Saisie from '@/components/generiques/Saisie.vue';
import AutoComplete from 'primevue/autocomplete';

const { idErreur, suggestions, autofocus, infobulle, desactive, placeholder } = defineProps({
    idErreur: String,
    suggestions: Array,
    autofocus: Boolean,
    infobulle: String,
    desactive: Boolean,
    placeholder: String
});

const valeur = defineModel('valeur', {
    type: String
});

const emit = defineEmits(['modifSaisie']);

const erreursSaisie = inject('erreursSaisie');

function modifierValeur(texte) {
    valeur.value = texte;
}

function mettreAJourSuggestions(event) {
    emit('modifSaisie', event.query);
}

</script>

<template>
    <Saisie :message-erreur="erreursSaisie[idErreur]">
        <AutoComplete 
            class="saisie-autocomplete"
            v-model="valeur" 
            :suggestions="suggestions" 
            :disabled="desactive"
            :placeholder="placeholder"
            :autofocus="autofocus" 
            v-tooltip.top="infobulle" 
            @update:modelValue="modifierValeur"
            @complete="mettreAJourSuggestions" />
    </Saisie>
</template>

<style scoped>

.saisie-autocomplete {
    max-height: inherit;
    border-radius: 5px;
}

</style>